<template>
  <el-dialog
    title="批量设置佣金"
    width="30%"
    :visible="show"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    append-to-body
    @close="handleClose"
  >
    <div>
      <div style="margin-bottom: 10px;">
        你正在对 {{length}} 个计划调整佣金。<br>
        确认后，选中计划的佣金将替换成当前设置比例。
      </div>
      佣金设置
      <el-input
        v-model="commissionAll"
        style="width: 200px;"
        placeholder="1~29"
      >
        <template slot="append">%</template>
      </el-input>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="show = false">取 消</el-button>
      <el-button type="primary" @click="submit">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import {matchNegativePart3} from "@/utils/regExp.js";
export default {
  name: "detailBatchSetPop",
  data() {
    return {
      show: false,
      commissionAll: '',
      length: 0,
    }
  },
  methods: {
    handleClose() {
      this.show = false;
    },
    open(length) {
      this.commissionAll = ''
      this.length = length
      this.show = true;
    },
    submit() {
      if(!matchNegativePart3.test(this.commissionAll) || (Number(this.commissionAll) < 1 || Number(this.commissionAll) > 29)) {
        this.$message.error('请输入1~29，最多1位小数')
        return
      }
      this.handleClose()
      this.$emit('submit', this.commissionAll)
    }
  }
}
</script>

<style scoped lang="less">

</style>



// WEBPACK FOOTER //
// src/views/pc/miniProgram/poiCps/components/detailBatchSetPop.vue